import { useMemo } from "react";

const BUTTON_TYPES = [
  {
    id: "default",
    style: "bg-white text-black hover:bg-gray-300",
  },
  {
    id: "negative",
    style: "bg-red-500 hover:bg-red-400",
  },
  {
    id: "positive",
    style: "bg-blue-500 hover:bg-blue-400",
  },
  {
    id: "theme",
    style: "bg-[var(--primary-color)] hover:bg-[var(--secondary-color)] ",
  },
];

const defaultStyles =
  "block rounded-md px-3 py-2 text-center text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:bg-gray-500";

/**
 * @typedef {"default" | "negative" | "positive"} ButtonType
 */

/**
 * @param {Object} props
 * @param {boolean} [props.hidden]
 * @param {ButtonType} props.type
 * @param {string} [props.className]
 * @param {string} [props.textContent]
 * @param {() => void} [props.onClick]
 * @param {boolean} [props.disabled]
 */
export default function Button({
  hidden = false,
  type = "default",
  className = "",
  textContent = "Button",
  onClick,
  disabled = false,
}) {
  const styling = useMemo(() => {
    const typeStyle =
      BUTTON_TYPES.find((button) => button.id === type)?.style || "";
    return `${defaultStyles} ${typeStyle} ${className}`;
  }, [type, className]);

  return (
    <button
      type="button"
      hidden={hidden}
      className={styling}
      onClick={onClick}
      disabled={disabled}
    >
      {textContent}
    </button>
  );
}
